import { axiosClient } from '@nx-frontend/shared/api';

interface GetAttachmentAnnotationParams {
  workspaceId: string;
  attachmentId: string;
}

export async function getAttachmentAnnotation({
  workspaceId,
  attachmentId,
}: GetAttachmentAnnotationParams): Promise<Record<string, unknown>> {
  let annotation = null;
  try {
    const response = await axiosClient.get(`/v2/api/workspaces/${workspaceId}/annotations/${attachmentId}`);
    annotation = response.data;
  } catch (err) {
    console.info('getAttachmentAnnotation error: ', err);
  }
  return annotation;
}
